import React from "react";
const PrivacyPolicy = () => {
  return (
    <div className="legal-container">
      <h1>Privacy Policy</h1>
      <p><strong>Last Updated:</strong> [01/03/2026]</p>

      <h2>1. Information We Collect</h2>
      <p>
        We may collect your Name, Email Address, Mobile Number,
        Login Credentials, Membership Details and Payment Information.
      </p>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To manage your membership account</li>
        <li>To process payments securely</li>
        <li>To send renewal reminders</li>
        <li>To provide support</li>
      </ul>

      <h2>3. Payment Security</h2>
      <p>
        We do not store card details. Payments are processed securely
        through our payment gateway provider.
      </p>

      <h2>4. Data Protection</h2>
      <p>
        We implement appropriate security measures to protect your data.
      </p>

      <h2>5. Contact Us</h2>
      {/* <p>Email: trackio.in@gmail.com</p> */}
      {/* <p>Contact Number:+917879137990</p> */}
       <p>Contact Number:
         <a href="tel:+917879137990" className="footer__phone" style={{ color: "#555", textDecoration: "none" }}>
           📞 +917879137990
          </a>
          </p>
          <p>Email: 📧
       <a href="mailto:trakiiteam.in@gmail.com" style={{ color: "#555", textDecoration: "none" }}>  trakiiteam.in@gmail.com</a>
       </p>
    </div>
  );
};

export default PrivacyPolicy;